import { AppBar } from "@progress/kendo-react-layout";
import { useContext } from "react";
import { Helmet } from "react-helmet";
import { RevUserContext } from "../../context/UserContext";
import { useReduxSelector } from "../../redux/hooks";
import { IUserProfile } from "../../types/User/IUserProfile";
import { MimicBar } from "./MimicBar";
import { INavButtonsBarProps } from "./NavButton/NavButtonsBar";
import NavLogo, { NavLogoProps } from "./NavLogo";
import {
  INotificationsProps,
  Notifications,
} from "./Notifications/Notifications";
import ProfileNav, { ProfileNavProps } from "./ProfileNav/ProfileNav";
import { useGetUserProfileQuery } from "../../redux/api/BaseApi";
import React from "react";
import { FluentButtonBar } from "./NavButton/FluentButtonBar";

// Left here for testing purposes
// import { navStyle } from "./NavLogo";

export const PROFILE_NAV_CONTAINER_CLASS_NAME = "profile-nav";
const PROFILE_NAV_CONTAINER_STYLE = "inline-flex flex-grow justify-end";
const NAV_BUTTONS_CONTAINER = "nav-buttons-container";
const NAV_BUTTONS_CONTAINER_SMALL = "nav-buttons-container-small";
export const NAV_BUTTONS_ID = "nav-buttons";
const LOGO_CONTAINER_ID = "logo-container";
const LOGO_CONTAINER_STYLE =
  "flex flex-grow justify-center md:grid md:max-w-[256px] md:min-w-[256px]";
const defaultNavButtonsBarProps: INavButtonsBarProps = {
  navStyleOverride: 2,
  override: true,
  hideNav: false
};
const NavWrapper = () => {
  const preData = useContext<IUserProfile>(RevUserContext);
  const { data } = useGetUserProfileQuery();
  const postData = data ? data : preData;
  const mimicUid = useReduxSelector((s) => s.revI.mimicUid);

  const navLogoProps: NavLogoProps = {
    imgUrl: postData.Site_Logo_Url.startsWith('/') ? '.' + postData.Site_Logo_Url : postData.Site_Logo_Url,
    navStyle: postData?.Nav_Collapsed ? 2 : postData.Nav_Style,
  };
  const utilProps: ProfileNavProps = {
    data: postData,
    mimicUid: mimicUid,
  };
  const notificationsProps: INotificationsProps = {
    navColor: postData.Nav_Hex_Color,
  };
  const navContainer = (navLogoProps.navStyle == 2) ? NAV_BUTTONS_CONTAINER_SMALL : NAV_BUTTONS_CONTAINER

  return (
    <>
      <MimicBar />
      <Notifications props={notificationsProps} />
      <Helmet>
        <title>{postData.Site_Title}</title>
      </Helmet>
      <AppBar
        style={{
          zIndex: "100",
          display: "flex",
          justifyContent: "space-between",
          overflow: "visible",
          position: "relative",
          gap: "0px",
          paddingTop: "0px",
          paddingBottom: "0px"
        }}
      >
        <div className="md:flex flex-grow flex-wrap">
          {<NavLogoContainer props={navLogoProps} />}
          <div className={navContainer}>
            <FluentButtonBar {...navLogoProps} />
          </div>
        </div>
      </AppBar >
    </>
  );
};
export default NavWrapper;

const NavLogoContainer = ({ props }: { props: NavLogoProps }) => {
  return (
    <div id={LOGO_CONTAINER_ID} className={LOGO_CONTAINER_STYLE}>
      <NavLogo props={props} />
    </div>
  );
};

const ProfileNavContainer = ({ props }: { props: ProfileNavProps }) => {
  return (
    <div className={PROFILE_NAV_CONTAINER_STYLE}>
      <ProfileNav props={props} />
    </div>
  );
};

